import { Box, Icon, Image } from "@drone-js/core";
import { memo } from "react";

interface Props {
    checked: boolean;
    image: string;
    name: string;
}

export const PropertyImage = memo<Props>(({ checked, image, name }) => {
    return (
        <Box overflow="hidden" borderRadius="8" width="48px" height="48px" position="relative" flexShrink={0}>
            {checked && (
                <Box
                    position="absolute"
                    top="0"
                    right="0"
                    left="0"
                    bottom="0"
                    backgroundColor="base.overlay"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="8"
                    data-testid="location-filled"
                >
                    <Icon id="fill.symbol.check" color="base.inverted" size="24" />
                </Box>
            )}
            {image ? (
                <Image alt={name} src={image} width="48px" height="48px" objectFit="cover" loading="lazy" />
            ) : (
                <Box width="48px" height="48px" backgroundColor="base.inset" />
            )}
        </Box>
    );
});
